export default class EditorJSModel {
    time
    blocks
    version

    public constructor(data) {
        this.time = data.time ? data.time : Date.now()
        this.version = data.version ? data.version : '2.8.1'
        this.blocks = data.blocks ? data.blocks : []
    }

    get str(): string {
        let str = ''
        this.blocks.map((block) => {
            if (block.type == 'paragraph') {
                str = str + block.data.text
            }
        })
        return str
    }
}
